'use client';

import { ReactNode } from 'react';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle
} from '@components/ui/drawer';
import { cn } from '@utils/cn';

interface BottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  /** Vaul snap points, only for real preview→detail sheets. */
  snapPoints?: (number | string)[];
}

/**
 * Thin mobile-semantics wrapper over the existing Vaul Drawer (hard decision:
 * Vaul stays). Adds sheet radius, safe-area bottom padding, and an a11y title.
 */
export function BottomSheet({
  open,
  onOpenChange,
  title,
  description,
  children,
  contentClassName,
  snapPoints
}: BottomSheetProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} snapPoints={snapPoints}>
      <DrawerContent
        className={cn('rounded-t-xl pb-[var(--safe-bottom)]', contentClassName)}
      >
        {title || description ? (
          <DrawerHeader>
            {title ? <DrawerTitle>{title}</DrawerTitle> : null}
            {description ? (
              <DrawerDescription>{description}</DrawerDescription>
            ) : null}
          </DrawerHeader>
        ) : (
          <DrawerTitle className="sr-only">Sheet</DrawerTitle>
        )}
        {children}
      </DrawerContent>
    </Drawer>
  );
}
